import { render, staticRenderFns } from "./DataRequestCard.vue?vue&type=template&id=f671c5ee&"
import script from "./DataRequestCard.vue?vue&type=script&lang=js&"
export * from "./DataRequestCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports